const defaultStep = {
    id: 1,
    name: 'onboarding.steps_choose_name',
    slug: 'choose',
    description: 'onboarding.steps_choose_description',
    title: 'onboarding.steps_choose_title',
    subtitle: 'onboarding.steps_choose_subtitle',
    help: 'onboarding.choose_not_sure',
    header: 'onboarding.types_phone_header',
    skippable: false
}

export default {
    namespaced: true,
    state: {
        type: 1,
        step: 1,
        skipManufacturer: false,
        types: [
            {
                id: 1,
                icon: 'icon-phone',
                name: 'phone',
                header: 'onboarding.types_phone_header',
                eyebrow: 'onboarding.types_phone_eyebrow',
                recommend: true,
                title: 'onboarding.types_phone_title',
                desc: 'onboarding.types_phone_desc',
                features: [
                    'onboarding.types_phone_features_a',
                    'onboarding.types_phone_features_b',
                    'onboarding.types_phone_features_c',
                ],
                steps: [
                    defaultStep,
                    {
                        id: 2,
                        slug: 'configure',
                        name: 'onboarding.steps_configure_name',
                        description: 'onboarding.steps_phone_configure_description',
                        title: 'onboarding.steps_configure_title',
                        subtitle: 'onboarding.steps_phone_configure_subtitle',
                    },
                    {
                        id: 3,
                        slug: 'pair-device',
                        name: 'onboarding.steps_pair_name',
                        title: 'onboarding.steps_pair_title',
                        subtitle: 'onboarding.steps_pair_subtitle',
                        description: 'onboarding.steps_pair_description'
                    },
                    {
                        id: 4,
                        slug: 'done',
                        name: 'onboarding.steps_done_name',
                        description: 'onboarding.steps_done_description'
                    },
                ],
                support: {
                    title: 'onboarding.types_phone_support_title',
                    text: 'onboarding.types_phone_support_text',
                    buttonText: 'onboarding.types_phone_support_button'
                }
            },
            {
                id: 2,
                name: 'gps-tracker',
                icon: 'icon-chip',
                title: 'onboarding.types_gps_tracker_title',
                header: 'onboarding.types_gps_tracker_header',
                desc: 'onboarding.types_gps_tracker_desc',
                eyebrow: 'onboarding.types_gps_tracker_eyebrow',
                features: [
                    'onboarding.types_gps_tracker_features_a',
                    'onboarding.types_gps_tracker_features_b',
                    'onboarding.types_gps_tracker_features_c',
                ],
                steps: [
                    defaultStep,
                    {
                        id: 2,
                        slug: 'identify-device',
                        name: 'onboarding.steps_identify_name',
                        title: 'onboarding.steps_identify_title',
                        subtitle: 'onboarding.steps_identify_subtitle',
                        description: 'onboarding.steps_identify_description'
                    }, {
                        id: 3,
                        slug: 'network',
                        name: 'onboarding.steps_network_name',
                        title: 'onboarding.steps_network_title',
                        subtitle: 'onboarding.steps_network_subtitle',
                        description: 'onboarding.steps_network_description'
                    }, {
                        id: 4,
                        slug: 'configure',
                        name: 'onboarding.steps_configure_name',
                        title: 'onboarding.steps_configure_title',
                        subtitle: 'onboarding.steps_gps_configure_subtitle',
                        description: 'onboarding.steps_gps_configure_description'
                    }, {
                        id: 5,
                        name: 'onboarding.steps_connect_name',
                        slug: 'connect',
                        title: 'onboarding.steps_connect_title',
                        subtitle: 'onboarding.steps_connect_subtitle',
                        description: 'onboarding.steps_connect_description'
                    },
                ],
                support: {
                    title: 'onboarding.types_gps_tracker_support_title',
                    text: 'onboarding.types_gps_tracker_support_text',
                    buttonText: 'onboarding.types_gps_tracker_support_button'
                }
            },
        ]
    },
    getters: {
        types: state => state.types,
        type: state => state.type,
        skipManufacturer: state => state.skipManufacturer,
        currentStep: state => {
            return state.types[state.type - 1].steps[state.step - 1];
        },
        data(state) {
            return state.types[state.type - 1];
        }
    },
    mutations: {
        type(state, type) {
            state.type = type;
            state.skipManufacturer = false;
        },

        skipManufacturer(state, value) {
            state.skipManufacturer = !!value;
        },

        next(state) {
            state.step += 1;
        },

        back(state) {
            state.step -= 1;
        },

        setStep(state, step) {
            state.step = step;
        },

        setStepBySlug(state, name) {
            state.step = state.types[state.type - 1].steps.find(s => s.slug === name)?.id;
        },

        reset(state) {
            state.step = 1;
            state.skipManufacturer = false;
        }
    },
    actions: {

    },
}
